const EventEmitter = require('events');

import {newReq} from "@/core/request";

export class Employee extends EventEmitter {
    constructor(obj) {
        super();
        this.name = null;
        this.tags = null;
        this.teamId = null;
        this.disabled = false;
        this.trackActivity = true;
        this.enableScreenshots = true;
        this.employeeNumber = null;
        Object.assign(this, obj)
    }

    create(deviceIds) {
        return newReq('POST', `employees/create`, {
            employee: JSON.parse(JSON.stringify(this)),
            deviceIds: deviceIds || []
        })
    }
    update(...keys) {
        const updateObj = JSON.parse(JSON.stringify(this))
        Object.keys(this).forEach(key => {
            if (!(keys || []).includes(key))
                delete updateObj[key];
        })

        return newReq('POST', `employees/update`, {...updateObj, _id: this._id})
    }
    delete() {
        return newReq('POST', `employees/delete`, {
            employeeId: this._id,
        })
    }
}